(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hotspot-image"] && !Shopify.designMode) return;
  try {
    
const hotspots = document.querySelectorAll('[data-hotspot]');

hotspots.forEach(item => {
  const btn   = item.querySelector('.hotspot__btn');
  const card  = item.querySelector('.hotspot__card');
  const media = item.closest('.hotspot-media');

  btn.addEventListener('click', e => {
    e.stopPropagation();

    const wasActive = item.classList.contains('is-active');

    // Close all hotspots
    hotspots.forEach(h => {
      h.classList.remove('is-active', 'is-top');
      const c = h.querySelector('.hotspot__card');
      if (c) c.style.transform = '';
    });

    // Toggle off if already open
    if (wasActive) return;

    item.classList.add('is-active');

    const btnRect   = btn.getBoundingClientRect();
    const cardRect  = card.getBoundingClientRect();
    const mediaRect = media.getBoundingClientRect();
    const gap = 12;

    /* ===============================
       ONLY HORIZONTAL CLAMP
       (NO TOP FLIP — ALWAYS BOTTOM)
    =============================== */

    const centerX = btnRect.left + btnRect.width / 2;
    let shiftX = 0;

    const leftOverflow =
      (centerX - cardRect.width / 2) - mediaRect.left;

    const rightOverflow =
      mediaRect.right - (centerX + cardRect.width / 2);

    if (leftOverflow < gap) {
      shiftX = gap - leftOverflow;
    }

    if (rightOverflow < gap) {
      shiftX = -(gap - rightOverflow);
    }

    card.style.transform =
      `translateX(calc(-50% + ${shiftX}px)) scale(1)`;
  });
});

// Close hotspot on outside click
document.addEventListener('click', () => {
  hotspots.forEach(h => {
    h.classList.remove('is-active', 'is-top');
    const c = h.querySelector('.hotspot__card');
    if (c) c.style.transform = '';
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
